var Status;
(function (Status) {
    Status[Status["Idle"] = 1] = "Idle";
    Status[Status["Easing"] = 2] = "Easing";
})(Status || (Status = {}));
/* eslint no-return-assign: 0, no-sequences: 0, no-param-reassign: 0 */
var inOutQuad = function (t) { return (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t); };
// raf, caf polyfill
var caf = cancelAnimationFrame || clearTimeout;
var raf = requestAnimationFrame || (function (fn) { return setTimeout(function () { return fn(Date.now()); }, 1000 / 60); });
var Tween = /** @class */ (function () {
    function Tween(options) {
        if (options === void 0) { options = {}; }
        this._from = 0;
        this._to = 0;
        this._status = Status.Idle;
        this.tick = this.tick.bind(this);
        this.duration(options.duration);
        this._easing = options.easing || inOutQuad;
    }
    Tween.prototype.from = function (value) {
        return (this._from = value), this;
    };
    Tween.prototype.to = function (value) {
        return (this._to = value), this;
    };
    Tween.prototype.duration = function (ms) {
        if (ms === void 0) { ms = 650; }
        return (this._duration = ms), this;
    };
    Tween.prototype.stop = function (cb) {
        if (this._raf) {
            caf(this._raf);
            this._raf = undefined;
        }
        this._status = Status.Idle;
        if (typeof cb === 'function') {
            cb(this._to, this._from);
        }
        return this;
    };
    Tween.prototype.tick = function (iterate, done) {
        var _this = this;
        var startTime;
        var _a = this, _from = _a._from, _to = _a._to, _easing = _a._easing, _duration = _a._duration;
        var tick = function (now) {
            startTime = startTime || now;
            var elapsed = now - startTime;
            var progress = Math.min(elapsed / _duration, 1);
            if (progress <= 1) {
                iterate(_from + (_to - _from) * _easing(progress));
            }
            if (_this._status === Status.Easing) {
                if (progress >= 1) {
                    _this.stop(done);
                }
                else {
                    _this._raf = raf(tick);
                }
            }
        };
        this.stop();
        this._status = Status.Easing;
        this._raf = raf(tick);
    };
    return Tween;
}());

export default Tween;
//# sourceMappingURL=tween.js.map
